import * as React from 'react';
import { useSelector } from 'react-redux';

import { isPrintVersionPhoneVisibilitySelector } from 'shared/selectors/print';

import { BookButtonContainer } from './BookButtonContainer';
import { PhonesContainer } from './PhonesContainer';
import { SendMessageButtonContainer } from './SendMessageButton';
import { NewbuildingContactsContainerLoadable } from '../../components/contacts_aside';
import { isNewbuildingSelector, selectIsOfferPublished, selectCianPartner } from '../../selectors';
import { selectShouldRenderContacts } from '../../selectors/contacts/selectShouldRenderContacts';
import { selectorEntryToShowEnabled } from '../../selectors/contacts/selectorEntryToShowEnabled';

export const AsideContactsContainer = () => {
  const shouldRenderContactButtons = useSelector(selectShouldRenderContacts);
  const isPublished = useSelector(selectIsOfferPublished);
  const entryToShowEnabled = useSelector(selectorEntryToShowEnabled);
  const isNewbuilding = useSelector(isNewbuildingSelector);
  const isCianPartner = useSelector(selectCianPartner);
  const isPrintVersion = useSelector(isPrintVersionPhoneVisibilitySelector);

  if (!isPublished || entryToShowEnabled) {
    return null;
  }

  return (
    <>
      {isCianPartner && <BookButtonContainer />}
      {!isCianPartner && isNewbuilding && !isPrintVersion && (
        <NewbuildingContactsContainerLoadable contactsButton={<PhonesContainer />} callbackPlaceType="floating_block" />
      )}
      {!isCianPartner && !isNewbuilding && shouldRenderContactButtons && <PhonesContainer />}
      {shouldRenderContactButtons && <SendMessageButtonContainer />}
    </>
  );
};
